export interface Notice {
  id: string
  title: string
  status: string
  start: string
  end: string
  body: string
}

export const noticeStatusOptions = ['노출중', '예약', '임시', '종료됨']

export const noticesSpecification = {
  title: '공지사항',
  purpose: '사용자에게 전달할 운영 공지를 등록하고 노출 기간을 관리합니다.',
  functions: [
    '공지 등록·수정·삭제와 노출 상태 및 기간을 관리합니다.',
    '기간 필터로 과거와 예정 공지를 확인합니다.',
  ],
  connections: [
    '공지 등록 화면에서 제목, 본문, 노출 상태를 설정합니다.',
    '서비스 변경·점검 안내 등 사용자 고지가 필요할 때 공지 일정과 함께 사용합니다.',
  ],
  app: '노출중 상태의 공지는 사용자 앱 공지 영역에 표시되고, 예약·종료·임시 상태는 사용자에게 노출되지 않습니다.',
}

export const noticesDataModelGuide = [
  '공지 키: notice_id',
  '필수 속성: title, body, publish_status, start_at, end_at, created_at, updated_at',
  '사용자 앱은 노출중이며 현재 시간이 기간 안인 공지만 조회합니다.',
]

export const noticesImplementationGuide = [
  '화면 식별자: notices. 좌측 사이드 메뉴는 유지하고 메인 영역만 전환합니다.',
  '필수 데이터: 제목, 본문, 노출 상태, 시작일, 종료일, 등록·수정 시각.',
  '검색과 기간 조건으로 공지 이력을 조회합니다.',
  '등록·수정·삭제는 notice_id를 기준으로 처리하고 노출 상태와 기간을 함께 저장합니다.',
]

export const noticeEditorSpecification = {
  title: '공지 등록·수정',
  purpose: '사용자 앱 공지의 제목, 본문, 노출 상태와 기간을 등록하거나 수정하는 화면입니다.',
  functions: [
    '공지사항 목록의 공지 등록으로 새 공지를 만들고, 각 행 수정으로 기존 공지를 변경합니다.',
    '노출중·예약·임시·종료됨 상태와 기간을 설정합니다.',
  ],
  connections: [
    '공지사항 목록에서 등록·수정·삭제를 관리합니다.',
    '서비스 변경·점검 안내가 필요하면 공지 목록의 기간과 노출 상태를 기준으로 발행합니다.',
  ],
  app: '노출중이며 기간 안에 있는 공지만 사용자 앱 공지 영역에 표시됩니다.',
}

export const noticeEditorImplementationGuide = [
  '제목, 본문, 상태, 시작일, 종료일을 함께 검증해 notice_id로 저장합니다.',
  '사용자 앱 노출 여부는 노출중 상태와 현재 기간을 모두 만족하는지로 판단합니다.',
]

export const noticesStateDefinitions: [string, string, string][] = [
  ['노출중', '현재 기간에 사용자에게 표시', '사용자 앱 공지 영역에 노출'],
  ['예약', '시작일 전 대기', '시작 시각까지 미노출'],
  ['임시', '작성 중인 공지', '사용자 앱에 미노출'],
  ['종료됨', '종료일이 지난 공지', '사용자 앱에서 제거하고 이력만 보관'],
]
